import { render, staticRenderFns } from "./JobUpdate.vue?vue&type=template&id=6b4d8fc0&scoped=true"
import script from "./JobUpdate.vue?vue&type=script&lang=js"
export * from "./JobUpdate.vue?vue&type=script&lang=js"
import style0 from "./JobUpdate.vue?vue&type=style&index=0&id=6b4d8fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d8fc0",
  null
  
)

export default component.exports